<template>
  <div class="content">
    <div class="table-container">
      <h2 class="table-container-title">出库单</h2>
      <div class="filter-actions" v-if="formData.status==1">
        <el-select v-model="titleCompany" placeholder="请选择公司抬头">
          <el-option v-for="item in titleCompanyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button type="primary" @click="exportOutEntrepot" style="margin-left: 10px;">导出</el-button>
      </div>
      <div class="table-header-info">
        <span class="info-item"><strong>客户名称：</strong>{{formData.customerName}}</span>
        <span class="info-item"><strong>开单日期：</strong>{{parseTime(formData.createTime,'{y}/{m}/{d}')}}</span>
        <span class="info-item"><strong>单号：</strong>{{formData.number}}</span>
      </div>
      <el-table :data="formData.contentList" :span-method="handleSpan" border style="width: 100%" align="center"  class="custom-table">
        <el-table-column prop="index" label="序号" align="center" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.total">{{scope.row.categoryName}}</span>
            <span v-else-if="scope.row.remarkLast">{{scope.row.categoryName}}</span>
            <span v-else>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" align="center" label="品名">
          <template slot-scope="scope">
            {{scope.row.categoryName}}
          </template>
        </el-table-column>
        <el-table-column prop="quantity" align="center" label="数量">
          <template slot-scope="scope">
            {{scope.row.quantity}}
          </template>
        </el-table-column>
        <el-table-column prop="units" align="center" label="单位">
          <template slot-scope="scope">
            {{scope.row.units}}
          </template>
        </el-table-column>
        <el-table-column label="价格" prop="unitPrice" align="center">
          <template slot-scope="scope">
            {{scope.row.unitPrice}}
          </template>
        </el-table-column>
        <el-table-column label="货款" prop="paymentGoods" align="center">
          <template slot-scope="scope">
            {{scope.row.paymentGoods}}
          </template>
        </el-table-column>
        <el-table-column label="备注" header-align="center" align="left" width="400">
          <template slot-scope="scope">
            <!-- 使用 v-html 指令渲染富文本内容 -->
            <div v-html="replaceNewlines(scope.row.remark)"></div>
          </template>
        </el-table-column>
      </el-table>
       <div class="table-footer-info">
        <span class="footer-info-item"><strong>制单：</strong></span>
        <span class="footer-info-item"><strong>财务：</strong></span>
        <span class="footer-info-item"><strong>仓库：</strong></span>
        <span class="footer-info-item"><strong>客户签名：</strong></span>
      </div>
    </div>

      <div class="table-container" v-if="!!shipmentId">
          <Shipment :shipmentId="shipmentId"/>
      </div>

    <!-- 审核记录表格 -->
    <div class="table-container">
      <div class="audit-table-container">
        <h2 class="table-container-title" style="margin-bottom: 10px;">审核记录</h2>
      </div>
      <el-table :data="tableData" border class="custom-table" style="width: 100%;margin-top: 0px">
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="activityName" label="名称" align="center"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
        <el-table-column prop="assignee" label="负责人" align="center"></el-table-column>
        <el-table-column prop="status" label="处理结果" align="center"></el-table-column>
        <el-table-column prop="reason" label="处理意见" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
  import { outEntrepotDetailById , historicActivityInstance} from "@/api/api.js";//附加单据
  import Shipment from "./info/Shipment.vue";
  export default {
    //name: "outEntrepotDetail",
      components: {Shipment},
    data() {
      return{
        id: this.$route.query.id,
        processId: this.$route.query.processId,
        shipmentId: this.$route.query.shipmentId,
        formData:{},//表单数据
        tableData:[],
        titleCompanyList: [
          {
            value: '1',
            label: '桔子智联'
          }, {
            value: '2',
            label: '中为捷讯'
          }
        ],
        titleCompany: '1'//默认值
      }
    },
    methods: {
      //导出excel出库单
      exportOutEntrepot() {
        let params = {id: this.formData.id, titleCompany: this.titleCompany};
        this.download('/outEntrepot/exportExcel', params, 'outEntrepot_' + this.formData.number + '.xlsx');
      },
      initData(){
        outEntrepotDetailById({id: this.id}).then(res=>{
          this.formData = res.data.data;
          let amountRow={total: true,categoryName:'合计',quantity:res.data.data.total,remark:res.data.data.noticeRemark}
          let remarkRow={remarkLast: true,categoryName:'备注',remark:res.data.data.remark}
          this.formData.contentList.push(amountRow,remarkRow)
        });
      },
      initHistoricActivity(){
        if (this.processId) {
            historicActivityInstance({processInstanceId: this.processId}).then(res=>{
                this.tableData = res.data.data;
            });
        }
      },
      handleSpan({ row, column, rowIndex, columnIndex }) {
        if (row.total) {
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 2 }; // 合并序号、品名
          } else if (columnIndex < 2) {
            return { rowspan: 1, colspan: 0 }; // 隐藏品名
          } else if (columnIndex === 2) {
            return { rowspan: 1, colspan: 1 }; // 显示数量列
          } else if (columnIndex === 6) {
            return { rowspan: 1, colspan: 4 }; // 显示1行4列
          }else {
            return { rowspan: 1, colspan: 0 }; // 隐藏其他列
          }
        } else if (row.remarkLast) {
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 1 };
          } else if(columnIndex === 6) {
            return { rowspan: 1, colspan: 6 }; // 备注内容跨后七列
          }else{
            return { rowspan: 1, colspan: 0 }; // 隐藏其他列
          }
        }
      },
      // 将 \n 替换为 <br> 标签的方法
      replaceNewlines(text) {
        if (text) {
          return text.replace(/\n/g, "<br>");
        }
        return "";
      },

    },
    created() {
      this.titleCompany = this.titleCompanyList[0].value;
    },
    computed: {},
    mounted() {
      this.initData()
      this.initHistoricActivity()
    },
    
  };
</script>
<style scoped lang="less">
  .content {
    display: flex;
    justify-content: center;
    padding-top: 40px;
    flex-direction: column;
    align-items: center;
  }
  .table-container {
    width: 100%;
    max-width: 1300px;
    margin-bottom: 80px; // 增加表格间的间距
    .table-container-title{
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .table-header-info {
      margin-bottom: 6px;
      display: flex;
      gap: 100px; /* 调整信息项之间的间距 */
    }
    .table-footer-info {
      margin-top: 6px;
      display: flex;
      gap: 120px; 
    }
    .info-item {
      font-size: 18px;
    }
    .footer-info-item{
      font-size: 15px;
    }
    .el-table {
      text-align: center;
      td, th {
        text-align: center !important;
      }
    }
    .el-form-item span {
      display: inline-block;
      padding-top: 6px;
    }
    .filter-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 20px;
    }
    /deep/ .custom-table{
      border: 1px solid black;
      /* 表头样式 */
      .el-table__header {
        background-color: black;
        color: white;
      }
      /* 表格主体样式 */
      .el-table__body {
        background-color: white;
      }
      /* 单元格边框样式 */
      .el-table__body-wrapper td {
        border-color: black !important;
      }
      .el-table__header-wrapper th {
        border-color: black !important;
      }
      /* 单元格之间的分隔线 */
      .el-table__body-wrapper tr td {
        border-right: 1px solid black;
      }
       .el-table__body-wrapper tr td:last-child {
        border-right: none;
      }
      /* 表头分隔线样式 */
      .el-table__header-wrapper th.is-leaf {
        border-bottom: 1px solid black;
      }
      /* 表格底部边框样式 */
      .el-table__body-wrapper tr:last-child td {
        border-bottom: 1px solid black;
      }

    }
    
  }
  /* 可添加样式控制富文本内容的显示 */
  .el-table .el-table__cell div[v-html] {
    word-break: break-word; /* 允许长单词换行 */
  }
  /* 设置表头字体大小和粗细 */
  /deep/ .el-table thead th {
    font-size: 16px; 
    font-weight: 600; 
  }
  /* 设置表格内容字体大小和粗细 */
  /deep/ .el-table tbody td {
    font-size: 15px; 
    font-weight: 500; 
  }
  .audit-table-container {
    border: 1px solid black; // 添加黑色边框
    padding-top: 10px; // 添加内边距，让内容与边框有一定间距
  }
  
</style>


